import EllipsisToolTip from "../../../../../../base/basicComponents/ellipsisToolTip";
import HistoricalVersionComponent from "../../../../../../base/basicComponents/historicalVersionComponent";
import { FileStatusDiv } from "../../../../../../base/basicComponents/status";
import { flowBusinessIdMap } from "../../../../../publicDictionaryValues";
import UpdateSupportingFileTbody from "../../../../supportingFileSections/fields/supportingFileTbody/updateSupportingFileTbody";
import { PreviewFileLink } from "app/pages/previewFile";

export default class UpdateProcedureFileTbody extends UpdateSupportingFileTbody {
  /**
   * function about show link if column type is link
   * @param {*} rowColumn
   * @param {*} column
   * @returns
   */
  returnFileName = (rowColumn: any, column: any, row: any) => {
    const fileId = row.data.find((item: any) => item.name === "fileId").value;
    const fileKey = row.data.find((item: any) => item.name === "fileKey").value.trim();
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink fileId={fileId} fileName={rowColumn.value}>
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
        />
        {/* @ts-ignore */}
        {this.props.isShowHistoryVersion && (
          <HistoricalVersionComponent
            fileId={fileId}
            fileKey={fileKey}
            flowBusinessId={flowBusinessIdMap.procedureFile}
          />
        )}
        {rowColumn.tagValue !== null && <FileStatusDiv status={rowColumn.tagValue} />}
      </div>
    );
  };
}
